function fn_layout_header() {
    var $fn = $("#layout_header")

    if ($fn.length) {

        $fn.after('<nav id="layout_nav" class="ssm-nav" role="presentation"><div class="elm_head"></div><div class="elm_content"></div><ul class="elm_lang"></ul></nav>');

        var $layout_nav = $(document).find("#layout_nav"),
            $logo = $fn.find(".elm_logo").clone(),
            $nav = $fn.find(".elm_nav"),
            $header = $fn.find(".elm_header"),
            $langs = $fn.find(".elm_langs a"),
            $search = $fn.find(".col--search .elm_search");

        $layout_nav.find(".elm_head").append($logo);
        $layout_nav.find(".elm_content").append($nav.clone());
        $layout_nav.find(".elm_content").append($search.clone());
        $layout_nav.find(".part_category_picker").parents(".submenu-pages").remove();
        $langs.each(function () {
           $(this).clone().appendTo($layout_nav.find(".elm_lang")).wrap("<li>");
        });

        $('.ssm-nav').slideAndSwipe();

        $(window).scroll(function() {
            if ($(window).scrollTop() > 150){
                $nav.parents(".elm_nav_wrapper").addClass("mod--scrolled");
                $layout_nav.next("#layout_main").addClass("mod--scrolled");
            }
            else {
                $nav.parents(".elm_nav_wrapper").removeClass("mod--scrolled");
                $layout_nav.next("#layout_main").removeClass("mod--scrolled");
            }

            $(".elm_langs ul").stop(true,false).slideUp(500,function () {
                $(".elm_langs .mod--focus").removeClass("mod--focus");
            });
        });

        $fn.on("click","[data-langs]",function (e) {
            e.preventDefault();
            var $this = $(this);

            $this.toggleClass("mod--focus");
            $this.siblings("ul").stop(true,false).slideToggle(500);
        });

        $fn.on("click","[data-search-toggle]",function (e) {
            e.preventDefault();
            var $this = $(this);
            $this.hide();
            $this.siblings("form").fadeIn(500);
        });

        // $fn.find("[data-submenu]").hover(
        //     function () {
        //         $('.submenu').slideDown(500);
        //     },
        //     function () {
        //         // $('.submenu').slideUp(500);
        //     }
        // );

        $(window).on("resize",function () {
            if ($(window).width() < 960){
                $(".submenu").hide();
            }
        })
    }
}